import * as Animate from "react-reveal";

const AboutWhyMattersSection = () => {
  return (
    <section
      className="py-16 md:py-20 lg:py-24 px-4"
      style={{ background: "#fdf2df" }}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Why this work matters
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black tracking-[-0.03em] text-primary">
                When capability becomes visible, opportunity can move further.
              </h2>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div>
              <p className="text-gray font-poppins text-base leading-relaxed mb-6">
                Emerging markets are full of people with the ability to
                contribute to important work. Access to structured learning,
                credible evidence and global companies helps that ability become
                economic progress.
              </p>
              <p className="text-gray font-poppins text-base leading-relaxed">
                Our role is to make the journey clearer for learners and more
                dependable for companies—without losing the human judgement and
                support that meaningful work requires.
              </p>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default AboutWhyMattersSection;
